import { Sound } from "@pixi/sound";

export let betValueGlobal: number = 1;
export function setBetValueGlobal(val: number): void {
    betValueGlobal = val;
}


export let isSoundBtnOnGlobal: boolean = true;
export function setIsSoundBtnOnGlobal(val: boolean): void {
    isSoundBtnOnGlobal = val;
    console.log(val);
}


export let isMusicBtnOnGlobal: boolean = true;
export function setIsMusicBtnOnGlobal(val: boolean): void {
    isMusicBtnOnGlobal = val;
    console.log(val);
}

export let isGameAlreadyLoaded: boolean = false;
export function setIsGameAlreadyLoaded(val: boolean): void {
    isGameAlreadyLoaded = val;
}


// export let isFullscreenBtnOnGlobal: boolean = false;
// export function setIsFullscreenBtnOnGlobal(val: boolean): void {
//     isFullscreenBtnOnGlobal = val;
// }



export let spinResponseDataGlobal: any;
export function setSpinResponseDataGlobal(val: any): void {
    spinResponseDataGlobal = val;
}


let _currentRespinIndex: number = 0; // Private variable to hold the current value.

export const RespinIndex = {
    get value(): number {
        return _currentRespinIndex;
    },
    set value(newValue: number) {
        _currentRespinIndex = newValue;
    },
    increase(): void {
        _currentRespinIndex++;
    },
    reset(): void {
        _currentRespinIndex = 0;
    }
};



export let currentBackgorundMusic: Sound | null = null;
export function setBackgorundMusic(val: Sound): void {
    currentBackgorundMusic = val;
}

export const currentBackgorundMusicVolume: number = 0.75;


export let isQuickBtnOnGlobal: boolean = false;
export function setIsQuickBtnOnGlobal(val: boolean): void {
    isQuickBtnOnGlobal = val;
}

export let isSuperQuickBtnOnGlobal: boolean = false;
export function setIsSuperQuickBtnOnGlobal(val: boolean): void {
    isSuperQuickBtnOnGlobal = val;
}

export let jurisdictionGlobal: string = "";
export function setJurisdictionGlobal(val: string): void {
    jurisdictionGlobal = val;
}

export let willBannerAutoProceedGlobal: boolean = false;
export function setBannerAutoProceedGlobal(val: boolean): void {
    willBannerAutoProceedGlobal = val;
}


let resolveMaxWinClosed: (() => void) | null = null;

export let isMaxWinBtnClosedGlobal: boolean = false;

export function setMaxWinBtnClosedGlobal(val: boolean): void {
    isMaxWinBtnClosedGlobal = val;

    if (val && resolveMaxWinClosed) {
        resolveMaxWinClosed();
        resolveMaxWinClosed = null;
    }
}

export function waitUntilMaxWinBtnClosed(): Promise<void> {
    return new Promise<void>((resolve) => {
        resolveMaxWinClosed = resolve;
    });
}

export let languageGlobal: string = "";
export function setLanguageGlobal(val: string): void {
    languageGlobal = val;
}

export let isMobile: Boolean = false;
export function setMobileDetect(val: Boolean): void {
    isMobile = val;
}
export function getMobileDetect(): Boolean  {
    return isMobile;
}

export let linesConfigGlobal: number[][] = [];
export function setLinesGlobal(val: string[][]): void {
    // Convert string[][] to number[][]
    const converted: number[][] = val.map(line =>
        line.map(cell => Number(cell))
    );
    linesConfigGlobal = converted;
}

export let isSlamClickedGlobal: boolean = false;
export function setIsSlamClickedGlobal(val: boolean): void {
    isSlamClickedGlobal = val;
}

export interface IBetDetails {
    betAmount: number,
    bonusBuy: boolean,
    bonusBuyId: string,
}

let betDetails: IBetDetails = {
    betAmount: 0,
    bonusBuy: false,
    bonusBuyId: "",
}

export function setCurrentRoundBetDetails(betAmount: number, bonusBuy: boolean, bonusBuyId: string) {
    betDetails.betAmount = Number(betAmount) / 100;
    betDetails.bonusBuy = bonusBuy;
    betDetails.bonusBuyId = bonusBuyId;
}

export function getCurrentRoundBetDetails(): IBetDetails {
    return betDetails;
}

export let baseMeterVisibility: boolean = false;
export function getbaseMeterVisibility(): boolean {
    return baseMeterVisibility;
}
export function setbaseMeterVisibility(visible: boolean): void {
    baseMeterVisibility = visible;
}

interface ReelPosition {
    posX: number;
    posY: number;
}
type PositionData = Record<number, ReelPosition>;
export function landscapeMeterPositions(): PositionData[]{
    return [
    { "3": { posX: getMobileDetect() ? 350 : 397, posY: getMobileDetect() ? 1260 : 1346 } },
    { "4": { posX: getMobileDetect() ? 350 : 397, posY: getMobileDetect() ? 1260 : 1346 } },
    { "5": { posX: getMobileDetect() ? 350 : 397, posY: getMobileDetect() ? 1260 : 1346 } },
    { "6": { posX: getMobileDetect() ? 460 : 500, posY: getMobileDetect() ? 1260 : 1346 } },
    { "7": { posX: getMobileDetect() ? 510 : 550, posY: getMobileDetect() ? 1260 : 1346 } },
    { "8": { posX: getMobileDetect() ? 560 : 600, posY: getMobileDetect() ? 1260 : 1346 } },
    { "9": { posX: getMobileDetect() ? 610 : 650, posY: getMobileDetect() ? 1260 : 1346 } },
    { "10": { posX: getMobileDetect() ? 610 : 650, posY: getMobileDetect() ? 1260 : 1346 } }
];}

export let portraitMeterPositions: PositionData[] = [
    { "3": { posX: 1024, posY: 1050 } },
    { "4": { posX: 1024, posY: 1050 } },
    { "5": { posX: 1024, posY: 1050 } },
    { "6": { posX: 1024, posY: 1050 } },
    { "7": { posX: 1024, posY: 1050 } },
    { "8": { posX: 1024, posY: 1050 } },
    { "9": { posX: 1024, posY: 1050 } },
    { "10": { posX: 1024, posY: 1050 } }
]

export function landscapeLogoPositions(): PositionData[]{ 
    return [
    { "3": { posX: getMobileDetect() ? 350 : 397, posY: 686 } },
    { "4": { posX: getMobileDetect() ? 350 : 397, posY: 686 } },
    { "5": { posX: getMobileDetect() ? 350 : 397, posY: 686 } },
    { "6": { posX: getMobileDetect() ? 440 : 480, posY: 686 } },
    { "7": { posX: getMobileDetect() ? 510 : 550, posY: 686 } },
    { "8": { posX: getMobileDetect() ? 560 : 600, posY: 686 } },
    { "9": { posX: getMobileDetect() ? 610 : 650, posY: 686 } },
    { "10": { posX: getMobileDetect() ? 610 : 650, posY: 686 } }
];}

export let portraitLogoPositions: PositionData[] = [
    { "3": { posX: 1024, posY: 180 } },
    { "4": { posX: 1024, posY: 180 } },
    { "5": { posX: 1024, posY: 180 } },
    { "6": { posX: 1024, posY: 180 } },
    { "7": { posX: 1024, posY: 180 } },
    { "8": { posX: 1024, posY: 180 } },
    { "9": { posX: 1024, posY: 180 } },
    { "10": { posX: 1024, posY: 180 } }
]